import { render } from "./HumanRights.vue?vue&type=template&id=67b02cf6&scoped=true"
import script from "./HumanRights.vue?vue&type=script&lang=js"
export * from "./HumanRights.vue?vue&type=script&lang=js"

import "./HumanRights.vue?vue&type=style&index=0&id=67b02cf6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b02cf6"]])

export default __exports__